module.exports = __webpack_public_path__ + "static/img/gptModel12.6213c488.png";